<template>
    <div>
        <el-dialog :title="'付款单管理[' + detailsInfo.Orders_Payment_DocNo + ']'" :close-on-click-modal="isclose" :visible.sync="dialogVisible"
            width="1200px" :before-close="handleClose">
            <div class="details-box">
                <el-row :gutter="20" class="payment-details-info">
                    <el-col :span="12">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款金额 ：</div>
                            <div class="red-text">￥{{ Number(detailsInfo.Orders_Payment_Amount || 0).toFixed(2) }}</div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款方式：</div>
                            <div>{{ detailsInfo.Orders_Payment_Name }}</div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款状态：</div>
                            <div>
                                <span :class="judgeColor(orderPaymentStatus)">
                                    {{ orderPaymentStatus}}
                                </span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款确认状态：</div>
                            <div>
                                <span  :class="judgeColor(orderAuditStatus)">
                                    {{ orderAuditStatus }}
                                </span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">备注：</div>
                            <div>
                                {{ detailsInfo.Orders_Payment_Note }}
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">时间：</div>
                            <div class="rows">{{ elformatDate(detailsInfo.Orders_Payment_Addtime, 'yyyy/M/dd HH:mm:ss') }}</div>
                        </div>
                    </el-col>
                </el-row>
                <div class="details-box-title" style="margin-top: 20px;">付款凭证</div>
                <el-table :data="tableData" border style="width: 100%; margin-top: 10px"
                    :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column prop="ID" label="ID" align="center"></el-table-column>
                    <el-table-column prop="DiscountCateName" label="订单类型" align="center"></el-table-column>
                    <el-table-column prop="Receipt_BankName" label="汇入银行" align="center"></el-table-column>
                    <el-table-column prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                    <el-table-column prop="Receipt_Code" min-width="150px" label="汇款单位" align="center"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Receipt_PayDate" label="付款日期" align="center">
                        <template v-slot="scope">
                            {{elformatDate(scope.row.Receipt_PayDate) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Receipt_Amount" label="汇款金额" align="center">
                        <template v-slot="scope">￥{{ scope.row.Receipt_Amount }}</template>
                    </el-table-column>
                    <el-table-column prop="Distribute_Amount" label="本次分配金额" align="center">
                        <template v-slot="scope">￥{{ scope.row.Distribute_Amount }}</template>
                    </el-table-column>
                    <el-table-column prop="Receipt_Addtime" min-width="120px" label="录入时间" align="center">
                        <template v-slot="scope">
                            {{ elformatDate(scope.row.Receipt_Addtime, 'yyyy/M/dd HH:mm:ss') }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getDisplayAddressStr } from '@/utils/utils.js';
import BPMExamine from '@/components/BPMExamine';
export default {
    components: {
        BPMExamine
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: () => false
        },
        id: {
            type: Number
        },
    },
    data() {
        return {
            isShowDialog: false,
            isclose: false,
            tableData: [],
            orderAuditStatus: '', //付款单支付确认状态
            orderPaymentStatus: '', //付款单支付状态
            detailsInfo: {},




        };
    },
    watch: {
        dialogVisible(newval, oldval) {
            if (newval) {
                this.onInitData();
            }
        }
    },
    computed: {
        totalPrice() {
            let sum = 0;
            this.tableData.map((item) => {
                sum += Number(item.AmountPrice);
            });
            return sum.toFixed(2);
        }
    },
    methods: {
        //关闭弹窗
        handleClose() {
            this.$emit('handleClose', false);
        },
        onClose() {
            this.isShowDialog = false;
        }, // 查看BPM审核

        //初始化数据
        async onInitData() {
            this.isShowDialog = false;
            this.tableData = [];
            this.orderAuditStatus = '';
            this.orderPaymentStatus = '';

     

            this.detailsInfo = {};
            this.getPaymentDetails();
            this.getPaymentVoucherList();
        },
        //点击查看发货单
        getViewReceipt() {
            this.isShowDialog = true;
        },
        //获取详情信息
        getPaymentDetails() {
            this.$newsApi.contract.GetSPCOrdersPaymentByID({ ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.detailsInfo = res.data.data;
                    this.$newsApi.order.PaymentStatus({ status: this.detailsInfo.Orders_Payment_PaymentStatus }).then((res) => {
                        this.orderPaymentStatus = res.data.data;
                    });

                    this.$newsApi.order.PaymentAuditStatus({ status: this.detailsInfo.Orders_Payment_AuditStatus }).then((res) => {
                        this.orderAuditStatus = res.data.data;
                    });
                }
            });
        },
        //获取详情商品表格内容
        getPaymentVoucherList() {
            this.$newsApi.contract.SPCOrdersPayment_RelateReceiptList({ ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.tableData = res.data.data;
                }
            });
        },
    }
};
</script>

<style lang="scss" scoped>
$--color-primary: #4e6ef2;

/deep/.custom-label {
    width: 8vw;
}
.links {
    color: #409eff;
    cursor: pointer;
}

.hw-form-item-label {
    width: 160px !important;
}

.details-box {
    padding: 0px 20px 20px 20px;
}

.details-box-title {
    position: relative;
    padding-left: 10px;
    font-size: 16px;
    font-weight: 600;
}

.details-box-title:before {
    content: '';
    width: 4px;
    height: 16px;
    position: absolute;
    top: 2px;
    left: 0px;
    background: $--color-primary;
}

.hw-form-item {
    padding: 8px 0;
    display: flex;
    align-items: center;
    font-size: 14px;

    &-label {
        text-align: right;
        width: 120px;
        padding-right: 12px;
        color: #606266;
    }
}
.payment-details-info {
    border: 1px solid #ebeef5;
    padding-top: 10px;
    padding-bottom: 10px;
}
.red-text {
    color: #f56c6c;
    font-weight: bold;
}
.green-text {
    color: #67c23a;
    font-weight: bold;
}
</style>